/** declare only http service related requests */

import { HttpTokens, GetManHourCharts, GetManHourChartsQuery } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { paramsQueryString } from '@/utils/index';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description Get charts data for manhours, supports query
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const ManHourCharsGet = (
  prefix: string = 'incidents/man-hours/charts',
  tokens: HttpTokens,
  params?: GetManHourChartsQuery,
  hardRejection = true
): Promise<GetManHourCharts> => {
  const instance = new AxiosService({ method: 'get', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const queryUri = paramsQueryString(prefix, params || {});
  // const nice = niceUrl(instance.baseURL, noSlash('api/' + prefix));
  // token not yet set on backend
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  return instance.client
    .get(queryUri, config)
    .then((d: AxiosResponse<GetManHourCharts>) => {
      return d.data;
      // return Promise.reject(new Error('ups')) as any;
    })
    .catch(instance.defaultHandleError) as Promise<GetManHourCharts>;
};
